export default "__VITE_ASSET__CxE65GhA__"